import React from "react";
import {BaseContactFormContainer} from "app/contacts/components/BaseContactForm/BaseContactFormContainer";

export const SimpleContactForm = (props) =>
    <BaseContactFormContainer {...props} />;
